import React, { createRef } from 'react';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import classNames from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OutsideClickHandler from 'react-outside-click-handler';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';
import { createStructuredSelector } from 'reselect';
import withI18next from '~/../hocs/_withI18next';
import {
  makeSelectIsAuthenticated,
  makeSelectProfile,
} from '~/containers/AuthProvider/selectors';
import Config from '~/config';
import IconDownload from '~/components/svg/download.svg';

const roles = Config.getRoles();

@withI18next()
class ButtonDownloadAIPhoto extends React.Component {
  downloadButtonRef = createRef();

  state = {
    showPopover: false,
  };

  hidePopover = (e) => {
    if (!this.downloadButtonRef || !this.downloadButtonRef.current) return;
    if (this.downloadButtonRef.current.contains(e.target)) return;
    if (
      ['mypage-link-primary', 'popover-content', 'photo_text-color'].includes(
        e.target.className,
      )
    ) {
      return;
    }
    this.setState((state) => {
      if (state.showPopover) {
        this.downloadButtonRef.current.click();
      }
      return { showPopover: false };
    });
  };

  handleDownload = () => {
    const { profile, isAuthenticated, onClick } = this.props;
    const { showPopover } = this.state;
    if (
      !isAuthenticated ||
      (profile.role !== roles.PREMIUM && profile.role !== roles.PREMIUM_NO_ADS)
    ) {
      if (!showPopover) {
        this.setState({
          showPopover: true,
        });
      }
      return;
    }
    onClick();
  };

  render() {
    const { t, lng, loading, className } = this.props;
    const { showPopover } = this.state;
    const downloadButtonClassName = classNames(
      'btn',
      'btn-ac-primary',
      `btn-${Config.serviceType}`,
      'btn-block',
      'btn-download-ai',
      className,
    );

    let popoverPremium = <div />;
    if (showPopover) {
      popoverPremium = (
        <Popover
          id="download-ai-popover"
          style={{ width: 220, textAlign: 'center' }}
        >
          <span
            style={{ fontSize: 12 }}
            className={Config.getPrefixContent('text-color')}
            dangerouslySetInnerHTML={{
              __html: t('message_check_role_premium', {
                href: `${Config.getSiteURL()}/premium`,
              }),
            }}
          />
        </Popover>
      );
    }

    return (
      <OutsideClickHandler onOutsideClick={this.hidePopover}>
        <OverlayTrigger
          trigger={['click']}
          placement="bottom"
          overlay={popoverPremium}
        >
          <button
            ref={this.downloadButtonRef}
            className={downloadButtonClassName}
            onClick={this.handleDownload}
            disabled={loading}
          >
            {loading ? (
              <FontAwesomeIcon
                style={{ marginRight: 3, width: 18 }}
                icon={faSpinner}
                pulse
              />
            ) : (
              <IconDownload
                style={{
                  marginRight: 5,
                }}
              />
            )}
            {t('download')}
            <style jsx global>
              {`
                .btn-download-ai {
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  justify-content: center;
                  margin-bottom: 7px;
                }
                .btn-download-ai:hover {
                  border-color: #414042;
                  background: #414042;
                  color: #fff;
                }
              `}
            </style>
          </button>
        </OverlayTrigger>
      </OutsideClickHandler>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  isAuthenticated: makeSelectIsAuthenticated(),
  profile: makeSelectProfile(),
});
export default connect(mapStateToProps)(ButtonDownloadAIPhoto);
